import { VatNumberText } from "@/components/VatText.tsx";
import { Trans } from "@lingui/react/macro";

export const t_County = <Trans comment="Part of address">County</Trans>;
/** @public */
export const t_State = <Trans comment="Part of address">State</Trans>;

export const baLabels = {
    address_line1: <Trans>Street address</Trans>,
    address_line2: <Trans>Address line 2</Trans>,
    city: <Trans comment="Part of address">City</Trans>,
    company_name: <Trans>Company name</Trans>,
    company_reg_code: <Trans>Registration number</Trans>,
    company_vat_number: <VatNumberText />,
    state_code: t_State,
    country: <Trans comment="Part of address">Country</Trans>,
    county: (
        <>
            {t_County} / {t_State}
        </>
    ),
    customer_id_number: <Trans>Personal ID number</Trans>,
    customer_name: <Trans>Contact person's name</Trans>,
    customer_phone: <Trans>Contact person's phone</Trans>,
    email: <Trans>Invoice email</Trans>,
    post_index: <Trans>Zip/postal code</Trans>,
    referral_code: <Trans>Campaign code</Trans>,
    title: <Trans>Billing account name</Trans>,
    document: <Trans>Document file</Trans>,
    document_name: "",
    integration_id: <Trans comment="Unique ID number to integrate with external services">Integration ID</Trans>,
} as const;
